<template>
  <List class="overflow-y-auto">
    <template #items>
      <template v-if="!isLoading">
        <slot name="items" :items="items">
          <slot name="item" v-for="item in items" :key="item.id">
            <Item v-for="item in items" :key="item.id" />
          </slot>
        </slot>
      </template>
      <template v-else-if="slots.skeleton">
        <slot name="skeleton" v-for="i in 3" :key="i" />
      </template>
    </template>
  </List>
</template>

<script setup>
import { List, Item } from "@/Components/List";
import { useSlots } from "vue";

defineProps({
  items: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

const slots = useSlots();
</script>
